export default "__VITE_ASSET__8d2af58c__"